import { createFileRoute } from '@tanstack/react-router'
import { AiRoutingPage } from '../../components/AiRouting/AiRoutingPage'

export const Route = createFileRoute('/dev/ai-routing')({
  component: AiRoutingPage,
})
